import { Grid } from '@mui/material'
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect'
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem'
import InputFormItem from 'components/Common/ElementInForm/InputFormItem'
import { i18n } from 'i18n'
import React from 'react'
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.HomeVOCForm.fields';

const DetailVOC = () => {
    return (
        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" className='Input-Disabled' style={{ margin: "auto", width: "100%" }} >
            <Grid item xs={12} style={{ paddingLeft: "0px", paddingTop: "5px" }}>
                <InputFormItem
                    id="sVOCFormCode"
                    name="sVOCFormCode"
                    label={i18n(`${i18nField}.sInvoice`)}
                    required={false}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} style={{ paddingLeft: "0px" }}>
                <InputFormItem
                    id="sJobCode"
                    name="sJobCode"
                    label={i18n(`${i18nField}.sSheet`)}
                    required={false}
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} style={{ paddingLeft: "0px" }}>
                <AutoCompleteSelect
                    name="oVOCType"
                    options={[]}
                    label={i18n(`${i18nField}.sType`)}
                    required={false}
                    disabled={true}

                />
            </Grid>
            <Grid item xs={12} style={{ paddingLeft: "0px" }}>
                <AutoCompleteSelect
                    name="oVOCService"
                    options={[]}
                    label={i18n(`${i18nField}.sVOCService`)}
                    required={false}
                    disabled={true}
                />
            </Grid>
            <Grid item xs={12} style={{ paddingLeft: "0px" }}>
                <InputCustomLabel
                    id="sDetail"
                    name="sDetail"
                    label={i18n(`${i18nField}.sDetail`)}
                    required={false}
                    disabled={true}
                    multiline={true}
                    rows={9}
                    fullWidth
                />
            </Grid>
        </Grid>
    )
}

export default DetailVOC